module.exports = __webpack_public_path__ + "img/alpha.e6ddc245.png";